import ssoService from '@/services/ssoService';

export default {
  namespaced: true,
  state: {
    themeColor: '',
    layoutType: '',
    companyPermission: null,
    wording: [],
    isProduction: false,
    isCreateMember: false,
    LoginVerifyApi: '',
    createMemberApi: '',
    apiRedirectUrl: '',
  },
  mutations: {
    set(state, { name, value }) {
      state[name] = value;
    },
    push(state, { name, value }) {
      state[name].push(value);
    },
    delete(state, { name }) {
      state[name] = null;
    },
  },
  actions: {
    // 取得公司資訊
    getCompanyPermission: ({ state, commit, rootState }) => {
      // 若state中沒有公司資訊promise，呼叫API
      if (!state.companyPermission) {
        const param = { companyId: rootState.companyId };
        const companyPermission = ssoService.getCompanyPermission(param)
          .toPromise()
          .then((res) => res.response.data);
        commit('set', { name: 'companyPermission', value: companyPermission });
      }

      // 若state中已有公司資訊的promise，直接回傳
      return state.companyPermission;
    },
    // 取頁面設定資料
    getPageSetting: ({ state, commit, rootState }, page) => {
      // 若state中沒有頁面設定資料的promise，呼叫API
      if (!state[`pageSetting${page}`]) {
        const body = { companyId: rootState.companyId, memberSourceId: rootState.memberSourceId, page };
        const pageSetting = ssoService.getPageSetting(body)
          .toPromise()
          .then((res) => res.response.data[0]);
        commit('set', { name: `pageSetting${page}`, value: pageSetting });
      }

      // 若state中已有頁面設定資料的promise，直接回傳
      return state[`pageSetting${page}`];
    },
    postMobileVerifyCode({ rootState }, payload) {
      const body = {
        companyID: rootState.companyId,
        memberSourceID: rootState.memberSourceId,
        verifyTarget: payload,
      };
      return ssoService.postMobileVerifyCode(body).toPromise();
    },
    getMobileVerifySetting({ rootState }, payload) {
      const body = {
        companyID: rootState.companyId,
        paramCode: payload,
      };
      return ssoService.getMobileVerifySetting(body).toPromise();
    },
    postMobileVerifycodeVerifier({ rootState }, payload) {
      const body = {
        companyID: rootState.companyId,
        memberSourceID: rootState.memberSourceId,
        verifyTarget: payload.verifyTarget,
        verifyCode: payload.verifyCode,
      };
      return ssoService.postMobileVerifycodeVerifier(body).toPromise();
    },
    postWording({ commit, rootState }) {
      let language = (navigator.language || navigator.userLanguage || '').toLowerCase();

      if (language !== 'zh-cn') {
        language = 'zh-tw';
      }

      return ssoService.postWording({
        companyId: rootState.companyId,
        memberSourceID: rootState.memberSourceId,
        language,
      }).toPromise().then((res) => {
        if (res && res.response && res.response.success && res.response.data && res.response.data[0]) {
          commit('set', { name: 'wording', value: res.response.data[0].param || [] });
        }
      });
    },
    postLogin({ rootState }, payload = {}) {
      const body = {
        companyId: rootState.companyId,
        memberSourceId: rootState.memberSourceId,
        memberId: payload.memberId,
        memberAcntNo: payload.memberAcntNo,
        device: rootState.isMobile ? 'mobile' : 'pc',
      };
      return ssoService.postLogin(body).toPromise().then((res) => res.response).catch((err) => err);
    },
    getMemberSourceSetting({ commit, rootState }) {
      const params = {
        companyID: rootState.companyId,
        memberSourceID: rootState.memberSourceId,
      };
      return ssoService.getMemberSourceSetting(params).toPromise().then((memberSourceSettingRes) => {
        const res = memberSourceSettingRes.response;
        commit('set', { name: 'apiRedirectUrl', value: res.data[0].redirectUrl });
        if (res.data[0].setttingDetl.find((s) => s.paramType.toLowerCase() === 'login' && s.paramCode.toLowerCase() === 'loginverifyapi')) {
          const LoginVerifyApi = res.data[0].setttingDetl.find((s) => s.paramType.toLowerCase() === 'login' && s.paramCode.toLowerCase() === 'loginverifyapi').paramValue;
          commit('set', { name: 'LoginVerifyApi', value: LoginVerifyApi });
        }
        if (res.data[0].setttingDetl.find((s) => s.paramType.toLowerCase() === 'login' && s.paramCode.toLowerCase() === 'iscreatemember')) {
          const isCreateMember = res.data[0].setttingDetl.find((s) => s.paramType.toLowerCase() === 'login' && s.paramCode.toLowerCase() === 'iscreatemember').paramValue;
          if (typeof isCreateMember === 'string' && isCreateMember.toLowerCase() === 'true') { commit('set', { name: 'isCreateMember', value: true }); } else commit('set', { name: 'isCreateMember', value: false });
        }
        if (res.data[0].setttingDetl.find((s) => s.paramType.toLowerCase() === 'login' && s.paramCode.toLowerCase() === 'creatememberapi')) {
          const createMemberApi = res.data[0].setttingDetl.find((s) => s.paramType.toLowerCase() === 'login' && s.paramCode.toLowerCase() === 'creatememberapi').paramValue;
          commit('set', { name: 'createMemberApi', value: createMemberApi });
        }
        if (res.data[0].setttingDetl.find((s) => s.paramType.toLowerCase() === 'login' && s.paramCode.toLowerCase() === 'isproduction')) {
          const isProduction = res.data[0].setttingDetl.find((s) => s.paramType.toLowerCase() === 'login' && s.paramCode.toLowerCase() === 'isproduction').paramValue;
          if (typeof isProduction === 'string' && isProduction.toLowerCase() === 'true') { commit('set', { name: 'isProduction', value: true }); } else commit('set', { name: 'isProduction', value: false });
        }
        return res;
      }).catch((err) => err);
    },
    postDynamicLogin({ rootState, state, dispatch }, payload) {
      payload.companyID = rootState.companyId;
      payload.memberSourceID = rootState.memberSourceId;
      payload.memberID = rootState.memberId;
      const body = {
        isCreateMember: state.isCreateMember,
        APIName: state.LoginVerifyApi,
        createMemberApi: state.createMemberApi,
        validData: payload,
      };
      if (!state.isProduction) {
        payload.companyID = rootState.companyId;
        payload.memberSource = rootState.memberSourceId;
      }
      if (!state.isProduction) {
        return dispatch('postDigest', JSON.stringify(body)).then((res) => {
          if (res.response.success) {
            body.validData.digest = res.response.data[0].digest;
            return ssoService.postDynamicLogin(body);
          }
          return res.response;
        });
      }
      return ssoService.postDynamicLogin(body);
    },
    postDigest({ rootState }, payload) {
      const body = {
        companyID: rootState.companyId,
        memberSourceID: rootState.memberSourceId,
        payload,
      };
      return ssoService.postDigest(body);
    },
  },
};
